type CompanySearchResult = { name: string; id: number }[];

export class CompanyApi {
  constructor(private readonly config: Readonly<{ baseUrl: string }>) {}

  /**
   * searchCompanies
   */
  public searchCompanies(req: {
    searchTerm: string;
  }): Promise<CompanySearchResult> {
    return fetch(
      `${this.config.baseUrl}/api/company/search/?searchTerm=${req.searchTerm}`,
    ).then((res) => res.json());
  }
}
